import React from 'react';
import { useHistory, useLocation } from 'react-router-dom';
import Layout from 'app/components/common/Layout';
import PagePortal from 'app/components/common/PagePortal';
import HeadInfo from 'app/components/common/HeadInfo';
import JoinFirmSelectContainer from 'app/containers/join/JoinFirmSelectContainer';

function JoinFirmSelectPage({ associationCode, onSubmit }) {
	const history = useHistory();
	const location = useLocation();

	const handleFirmSelectOpen = () => {
		history.push({
			pathname: location.pathname,
			search: location.search,
			hash: '#page=firmdirect',
		});
	};

	return (
		<PagePortal>
			<Layout
				usePageHook
				title="상사선택"
				contentsType="normal"
				usePrevBtn
				useRightBtn
				useRightName="직접입력"
				onRight={handleFirmSelectOpen}
				usePc
			>
				<HeadInfo headTitle="상사선택 | 회원가입" />

				<JoinFirmSelectContainer
					associationCode={associationCode}
					onSubmit={onSubmit}
				/>
			</Layout>
		</PagePortal>
	);
}

export default JoinFirmSelectPage;
